import LocalStorage from 'Core/commons/LocalStorage';

const localStorageNamespace = 'listing_context';

export default {
    namespaced: true,
    state() {
        return {
            listingName: '',
            listingLocalStorage: {},
            columns: [],
            pagination: {
                limit: 25,
            },
            sorting: {},
            defaultColumns: [],
            defaultPagination: {
                limit: 25,
                offset: '',
                total: 0,
                currentPage: 1,
                count: 0,
            },
            defaultSorting: {
                order: '',
                direction: '',
            },
        };
    },
    getters: {
        getListingName: (state) => state.listingName,
        getColumns: (state) => state.columns,
        getPagination: (state) => state.pagination,
        getSorting: (state) => state.sorting,
        getDefaultColumns: (state) => state.defaultColumns,
        getDefaultPagination: (state) => state.defaultPagination,
        getDefaultSorting: (state) => state.defaultSorting,
        getPageCount: (state) => state.pageCount,
    },
    mutations: {
        setListingName: (state, payload) => {
            state.listingName = payload;
        },
        setColumns: (state, payload) => {
            state.columns = payload;
        },
        setPagination: (state, payload) => {
            state.pagination = payload;
        },
        setSorting: (state, payload) => {
            state.sorting = payload;
        },
        setDefaultColumns: (state, payload) => {
            state.defaultColumns = payload;
        },
        setDefaultPagination: (state, payload) => {
            state.defaultPagination = payload;
        },
        setDefaultSorting: (state, payload) => {
            state.defaultSorting = payload;
        },
        setListingLocalStorage: (state, payload) => {
            state.listingLocalStorage = payload;
        },
        setPageCount: (state, payload) => {
            state.pageCount = payload;
        },
    },
    actions: {
        initListingSettingsStore({ commit, rootState, state }, initialsDatas) {
            const defaultColumns = initialsDatas.defaultColumns ?? state.defaultColumns;
            const defaultPagination =
                initialsDatas.defaultPaginationColumns ?? state.defaultPagination;
            const defaultSorting = initialsDatas.defaultSorting ?? state.defaultSorting;
            const listingName = initialsDatas.listingName
                ? `${initialsDatas.listingName}_${rootState.user.id}`
                : '';

            commit('setListingName', listingName);
            commit('setDefaultColumns', defaultColumns);
            commit('setDefaultPagination', defaultPagination);
            commit('setDefaultSorting', defaultSorting);
            commit('setColumns', defaultColumns);
            commit('setPagination', defaultPagination);
            commit('setSorting', defaultSorting);

            commit(
                'setListingLocalStorage',
                new LocalStorage(localStorageNamespace, state.listingName),
            );

            const listingStorageValues = state.listingLocalStorage.get();
            if (listingStorageValues) {
                const columnsWithStorage = defaultColumns
                    .map((column) => {
                        const columnStorage = listingStorageValues.meta?.columns?.find(
                            (columnStorage) => columnStorage.code === column.code,
                        );
                        return columnStorage
                            ? { ...column, ...columnStorage, label: column.label }
                            : column;
                    })
                    .sort((a, b) => a.order - b.order);
                commit('setColumns', columnsWithStorage);
                commit(
                    'setPagination',
                    { limit: listingStorageValues.meta?.limit } ?? defaultPagination,
                );
                commit('setSorting', listingStorageValues.meta?.sorting ?? defaultSorting);
            }
        },
        updateColumns({ commit, dispatch }, columns) {
            commit('setColumns', columns);

            const sortedColumn = columns.find((column) => !!column.sortable?.direction);
            if (sortedColumn) {
                commit('setSorting', {
                    order: sortedColumn.sortable.orderBy,
                    direction: sortedColumn.sortable.direction,
                });
            }
            dispatch('updateLocalStorage', { columns });
        },
        updatePagination({ commit, dispatch }, pagination) {
            commit('setPagination', pagination);
            dispatch('updateLocalStorage', { limit: pagination.limit });
        },
        updateSorting({ commit, dispatch }, sorting) {
            commit('setSorting', sorting);
            dispatch('updateLocalStorage', { sorting });
        },
        updateLocalStorage({ state }, value) {
            const listingStorageValues = state.listingLocalStorage.get();
            state.listingLocalStorage.set({
                meta: {
                    ...(listingStorageValues?.meta ?? {}),
                    ...value,
                },
            });
        },
        resetPagination({ commit, getters }) {
            commit('setPageCount', 1);
            commit('setPagination', {
                limit: getters.getPagination.limit,
                currentPage: 1,
            });
        },

        updatePageCount({ commit }, pageCount) {
            commit('setPageCount', pageCount);
        },
    },
};
